import { IChatNotification } from "./interfaces";

// Resolves a notification's format-message params, translating any
// descriptors in `fixedContentParamsTranslateKeys` with the current intl.
export const resolveNotificationParams = (
  notification: IChatNotification,
  intl: { formatMessage: (descriptor: any, values?: any) => string }
): Record<string, any> => {
  const baseParams = notification.fixedContentParams || {};
  const translateKeys = notification.fixedContentParamsTranslateKeys;

  if (!translateKeys) {
    return baseParams;
  }

  const resolved: Record<string, any> = { ...baseParams };
  Object.keys(translateKeys).forEach(paramName => {
    const descriptor = translateKeys[paramName];
    if (!descriptor || !descriptor.id) return;
    resolved[paramName] = intl.formatMessage({
      id: descriptor.id,
      defaultMessage:
        descriptor.defaultMessage ?? baseParams[paramName] ?? descriptor.id,
    });
  });

  return resolved;
};
